<template>
  <div class="download-page">
    <div class="header">
      <div class="title">{{ $t('sao-ma-xia-zai-app') }}</div>
      <div class="desc">CoinOcean - {{ $t('jiao-yi') }}</div>
    </div>

    <div class="content">
      <div class="app-info">
        <div class="app-name">CoinOcean</div>
        <div class="app-version">v{{ appVersion }}</div>
        <div class="app-desc">{{ $t('common.trade2') }} | {{ $t('common.trade3') }} | {{ $t('common.trade4') }}</div>
      </div>

      <div class="download-section">
        <div class="qrcode-container">
          <div ref="qrcode" class="qrcode"></div>
          <div class="scan-tip">{{ $t('sao-ma-xia-zai-app') }}</div>
        </div>

        <div class="buttons">
          <div class="download-btn android" @click="downloadApp('android')">
            <div class="btn-text">
              <div class="platform-name">Android</div>
              <div class="download-text">{{ $t('xia-zai') }}</div>
            </div>
          </div>

          <div class="download-btn ios" @click="downloadApp('ios')">
            <div class="btn-text">
              <div class="platform-name">iOS</div>
              <div class="download-text">{{ $t('xia-zai') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="features">
        <div class="feature-item">
          <div class="feature-title">{{ $t('download.feature_title1') }}</div>
          <div class="feature-desc">{{ $t('download.feature_desc1') }}</div>
        </div>
        <div class="feature-item">
          <div class="feature-title">{{ $t('download.feature_title2') }}</div>
          <div class="feature-desc">{{ $t('download.feature_desc2') }}</div>
        </div>
        <div class="feature-item">
          <div class="feature-title">{{ $t('download.feature_title3') }}</div>
          <div class="feature-desc">{{ $t('download.feature_desc3') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { configList } from '@/api/user'

export default {
  name: 'DownloadPage',
  data() {
    return {
      appVersion: '3.0.0',
      mobileUrl: '',
      androidDownloadUrl: '',
      iosDownloadUrl: '',
      qrCodeInstance: null
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      configList().then(res => {
        if(res["mobile_url"] !== undefined) {
          this.mobileUrl = res.mobile_url.Value
          this.generateQRCode()
        }

        if(res["android_download"] !== undefined) {
          this.androidDownloadUrl = res.android_download.Value
        }

        if(res["ios_download"] !== undefined) {
          this.iosDownloadUrl = res.ios_download.Value
        }
      }).catch(err => {
        console.error(this.$t('download.load_config_error'), err)
      })
    },
    generateQRCode() {
      this.$nextTick(() => {
        if (this.mobileUrl && this.$refs.qrcode) {
          if (this.qrCodeInstance) {
            this.$refs.qrcode.innerHTML = ''
          }

          const qrcodeUrl = this.mobileUrl + '/#/download'
          this.qrCodeInstance = new QRCode(this.$refs.qrcode, {
            text: qrcodeUrl,
            width: 180,
            height: 180,
            colorDark: '#0072F5',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        }
      })
    },
    downloadApp(platform) {
      let downloadLink = ''

      if (platform === 'android') {
        downloadLink = this.androidDownloadUrl
        if (downloadLink) {
          this.downloadWithATag(downloadLink)
        }
      } else if (platform === 'ios') {
        downloadLink = this.iosDownloadUrl
        if (downloadLink) {
          this.downloadWithATag(downloadLink)
        }
      }
    },
    downloadWithATag(url) {
      const a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      a.rel = 'noopener noreferrer'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>

<style scoped>
.download-page {
  width: 100%;
  padding: 40px 0;
  background-color: #f8f9fa;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

.title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.desc {
  font-size: 16px;
  color: #666;
}

.content {
  max-width: 1000px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 40px;
}

.app-info {
  text-align: center;
  margin-bottom: 40px;
}

.app-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.app-version {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.app-desc {
  font-size: 14px;
  color: #666;
}

.download-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 60px;
}

.qrcode-container {
  text-align: center;
}

.qrcode {
  width: 180px;
  height: 180px;
  margin-bottom: 12px;
}

.scan-tip {
  font-size: 14px;
  color: #666;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0072F5;
  color: white;
  padding: 15px 30px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.download-btn:hover {
  background-color: #0060cc;
}

.android {
  background-color: #3ddc84;
}

.android:hover {
  background-color: #2cc073;
}

.ios {
  background-color: #000;
}

.ios:hover {
  background-color: #333;
}

.btn-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.platform-name {
  font-size: 16px;
  font-weight: bold;
}

.download-text {
  font-size: 14px;
}

.features {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.feature-item {
  flex: 1;
  text-align: center;
  padding: 20px;
}

.feature-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.feature-desc {
  font-size: 14px;
  color: #666;
}

@media (max-width: 768px) {
  .content {
    padding: 20px;
  }

  .download-section {
    flex-direction: column;
    gap: 30px;
  }

  .features {
    flex-direction: column;
  }
}
</style>